import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@phosphor-icons/react";
import { toast } from "sonner";
import Brand from "@/components/Brand";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { hydrateSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const raw = (loc.hash || window.location.hash || "").replace(/^#/, "");
    const params = new URLSearchParams(raw);
    const sid = params.get("session_id");
    if (!sid) {
      toast.error("Missing Google session token");
      nav("/login", { replace: true });
      return;
    }

    api.post("/auth/google-session", { session_id: sid })
      .then((r) => {
        hydrateSession(r.data.token, r.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${r.data.user.name.split(" ")[0]}`);
        nav("/", { replace: true });
      })
      .catch((e) => {
        toast.error(e.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="text-center space-y-4">
        <Brand />
        <Spinner size={28} className="animate-spin text-primary mx-auto" />
        <p className="text-sm text-muted-foreground">Finishing your sign in…</p>
      </div>
    </div>
  );
}
